// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Drawer shell ─────────────────────────────────────────── */
.ncd-paper {
  width: min(880px, 96vw) !important;
  background: #f1f5f9 !important;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* ── Header ───────────────────────────────────────────────── */
.ncd-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 20px 24px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  border-bottom: 1px solid #e5e7eb;
}

.ncd-header-title {
  display: flex;
  align-items: center;
  gap: 10px;
}

.ncd-title {
  font-size: 1.35rem;
  font-weight: 800;
  color: #0f172a;
  letter-spacing: -0.02em;
}

.ncd-title-badge {
  background: #0f172a;
  color: #fff;
  font-size: 0.75rem;
  font-weight: 700;
  min-width: 22px;
  height: 22px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 7px;
}

.ncd-header-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.ncd-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 36px;
  padding: 0 16px;
  border-radius: 999px;
  font-size: 0.82rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
  white-space: nowrap;
}

.ncd-btn-ghost {
  background: #fff;
  border: 1.5px solid #e2e8f0;
  color: #1e293b;
}

.ncd-btn-ghost:hover:not(:disabled) {
  background: #f8fafc;
  border-color: #cbd5e1;
}

.ncd-btn-ghost:disabled {
  color: #94a3b8;
  cursor: default;
  opacity: 0.6;
}

.ncd-btn-primary {
  background: #2563eb;
  border: none;
  color: #fff;
  box-shadow: 0 2px 8px rgba(37, 99, 235, 0.25);
}

.ncd-btn-primary:hover {
  background: #1d4ed8;
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.35);
}

.ncd-close {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  border: none;
  background: transparent;
  color: #64748b;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.15s;
}

.ncd-close:hover {
  background: #f1f5f9;
  color: #0f172a;
}

/* ── Stat cards ───────────────────────────────────────────── */
.ncd-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));
  gap: 14px;
  padding: 18px 24px 6px;
}

.ncd-stat {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  background: #fff;
  border: 1px solid #eef2f7;
  border-radius: 16px;
  padding: 16px 18px;
  cursor: pointer;
  text-align: left;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
  transition:
    transform 0.12s,
    box-shadow 0.15s;
}

.ncd-stat:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.08);
}

.ncd-stat-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.ncd-stat-label {
  font-size: 0.8rem;
  font-weight: 600;
  color: #64748b;
}

.ncd-stat-value {
  font-size: 1.7rem;
  font-weight: 800;
  color: #0f172a;
  line-height: 1.1;
}

.ncd-stat-sub {
  font-size: 0.72rem;
  color: #94a3b8;
}

.ncd-stat-icon {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.ncd-stat-icon svg {
  font-size: 1.2rem;
}

/* ── Search ───────────────────────────────────────────────── */
.ncd-search {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 14px 24px 4px;
  padding: 11px 14px;
  background: #fff;
  border: 1px solid #e8edf3;
  border-radius: 12px;
}

.ncd-search-input {
  border: none;
  outline: none;
  background: transparent;
  font-size: 0.85rem;
  color: #334155;
  width: 100%;
}

.ncd-search-input::placeholder {
  color: #94a3b8;
}

/* ── Tabs row ─────────────────────────────────────────────── */
.ncd-tabs-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 24px;
  flex-wrap: wrap;
}

.ncd-seg {
  display: inline-flex;
  background: #e9eef5;
  border-radius: 12px;
  padding: 4px;
  gap: 2px;
}

.ncd-seg-btn {
  border: none;
  background: transparent;
  padding: 7px 16px;
  border-radius: 9px;
  font-size: 0.82rem;
  font-weight: 600;
  color: #64748b;
  cursor: pointer;
  transition: all 0.15s;
  white-space: nowrap;
}

.ncd-seg-btn.active {
  background: linear-gradient(180deg, #3b82f6, #2563eb);
  color: #fff;
  box-shadow: 0 2px 8px rgba(37, 99, 235, 0.3);
}

.ncd-pills {
  display: inline-flex;
  gap: 8px;
}

.ncd-pill {
  border: 1px solid #e2e8f0;
  background: #fff;
  padding: 7px 16px;
  border-radius: 999px;
  font-size: 0.8rem;
  font-weight: 600;
  color: #64748b;
  cursor: pointer;
  transition: all 0.15s;
}

.ncd-pill:hover:not(.active) {
  border-color: #cbd5e1;
}

.ncd-pill.active {
  background: #2563eb;
  border-color: #2563eb;
  color: #fff;
}

/* ── List ─────────────────────────────────────────────────── */
.ncd-list {
  flex: 1;
  overflow-y: auto;
  padding: 4px 24px 28px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

/* ── Card ─────────────────────────────────────────────────── */
.ncd-card {
  position: relative;
  display: flex;
  gap: 14px;
  background: #fff;
  border: 1px solid #eef2f7;
  border-radius: 16px;
  padding: 18px 20px;
  cursor: pointer;
  transition:
    box-shadow 0.15s,
    border-color 0.15s,
    opacity 0.15s;
}

.ncd-card:hover {
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
  border-color: #e2e8f0;
}

.ncd-card.read {
  opacity: 0.62;
}

.ncd-card-unread {
  position: absolute;
  top: 18px;
  left: 8px;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #2563eb;
}

.ncd-card-avatar {
  width: 46px;
  height: 46px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-weight: 700;
}

.ncd-emoji {
  font-size: 1.35rem;
  line-height: 1;
}

.ncd-card-main {
  flex: 1;
  min-width: 0;
}

.ncd-card-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
  margin-bottom: 7px;
}

.ncd-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 10px;
  border-radius: 999px;
  font-size: 0.72rem;
  font-weight: 600;
  background: #f1f5f9;
  color: #475569;
  text-transform: capitalize;
}

.ncd-prio-high {
  background: #fee2e2;
  color: #dc2626;
}

.ncd-prio-medium {
  background: #fef3c7;
  color: #d97706;
}

.ncd-prio-low {
  background: #ecfdf5;
  color: #059669;
}

.ncd-chip-new {
  background: #dbeafe;
  color: #2563eb;
}

.ncd-card-title {
  margin: 0 0 4px;
  font-size: 0.98rem;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: -0.01em;
}

.ncd-card-desc {
  margin: 0 0 12px;
  font-size: 0.85rem;
  color: #64748b;
  line-height: 1.5;
}

.ncd-card-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.ncd-card-meta {
  font-size: 0.8rem;
  color: #475569;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ncd-card-link {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  border: none;
  background: transparent;
  color: #2563eb;
  font-size: 0.82rem;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
}

.ncd-card-link:hover {
  text-decoration: underline;
}

.ncd-card-time {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 0.72rem;
  color: #94a3b8;
  white-space: nowrap;
  flex-shrink: 0;
  align-self: flex-start;
}

/* ── Empty ────────────────────────────────────────────────── */
.ncd-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 70px 20px;
  color: #94a3b8;
  font-size: 0.9rem;
}

@media (max-width: 640px) {
  .ncd-header {
    flex-direction: column;
    align-items: flex-start;
  }
  .ncd-card-time {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/posnavbar/components/NewNotificationDrawer/NewNotificationDrawer.css"],"names":[],"mappings":"AAAA,gEAAgE;AAChE;EACE,kCAAkC;EAClC,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,gEAAgE;AAChE;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,6DAA6D;EAC7D,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,gEAAgE;AAChE;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,4CAA4C;EAC5C;;oBAEkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,gEAAgE;AAChE;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA,gEAAgE;AAChE;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qDAAqD;EACrD,WAAW;EACX,4CAA4C;AAC9C;;AAEA;EACE,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA,gEAAgE;AAChE;EACE,OAAO;EACP,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,gEAAgE;AAChE;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf;;;iBAGe;AACjB;;AAEA;EACE,6CAA6C;EAC7C,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,sBAAsB;AACxB;;AAEA,gEAAgE;AAChE;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,aAAa;EACf;AACF","sourcesContent":["/* ── Drawer shell ─────────────────────────────────────────── */\n.ncd-paper {\n  width: min(880px, 96vw) !important;\n  background: #f1f5f9 !important;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n/* ── Header ───────────────────────────────────────────────── */\n.ncd-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 20px 24px;\n  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.ncd-header-title {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.ncd-title {\n  font-size: 1.35rem;\n  font-weight: 800;\n  color: #0f172a;\n  letter-spacing: -0.02em;\n}\n\n.ncd-title-badge {\n  background: #0f172a;\n  color: #fff;\n  font-size: 0.75rem;\n  font-weight: 700;\n  min-width: 22px;\n  height: 22px;\n  border-radius: 999px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 7px;\n}\n\n.ncd-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.ncd-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 36px;\n  padding: 0 16px;\n  border-radius: 999px;\n  font-size: 0.82rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.15s;\n  white-space: nowrap;\n}\n\n.ncd-btn-ghost {\n  background: #fff;\n  border: 1.5px solid #e2e8f0;\n  color: #1e293b;\n}\n\n.ncd-btn-ghost:hover:not(:disabled) {\n  background: #f8fafc;\n  border-color: #cbd5e1;\n}\n\n.ncd-btn-ghost:disabled {\n  color: #94a3b8;\n  cursor: default;\n  opacity: 0.6;\n}\n\n.ncd-btn-primary {\n  background: #2563eb;\n  border: none;\n  color: #fff;\n  box-shadow: 0 2px 8px rgba(37, 99, 235, 0.25);\n}\n\n.ncd-btn-primary:hover {\n  background: #1d4ed8;\n  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.35);\n}\n\n.ncd-close {\n  width: 38px;\n  height: 38px;\n  border-radius: 10px;\n  border: none;\n  background: transparent;\n  color: #64748b;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n\n.ncd-close:hover {\n  background: #f1f5f9;\n  color: #0f172a;\n}\n\n/* ── Stat cards ───────────────────────────────────────────── */\n.ncd-stats {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));\n  gap: 14px;\n  padding: 18px 24px 6px;\n}\n\n.ncd-stat {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 10px;\n  background: #fff;\n  border: 1px solid #eef2f7;\n  border-radius: 16px;\n  padding: 16px 18px;\n  cursor: pointer;\n  text-align: left;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n  transition:\n    transform 0.12s,\n    box-shadow 0.15s;\n}\n\n.ncd-stat:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.08);\n}\n\n.ncd-stat-text {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.ncd-stat-label {\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: #64748b;\n}\n\n.ncd-stat-value {\n  font-size: 1.7rem;\n  font-weight: 800;\n  color: #0f172a;\n  line-height: 1.1;\n}\n\n.ncd-stat-sub {\n  font-size: 0.72rem;\n  color: #94a3b8;\n}\n\n.ncd-stat-icon {\n  width: 38px;\n  height: 38px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.ncd-stat-icon svg {\n  font-size: 1.2rem;\n}\n\n/* ── Search ───────────────────────────────────────────────── */\n.ncd-search {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 14px 24px 4px;\n  padding: 11px 14px;\n  background: #fff;\n  border: 1px solid #e8edf3;\n  border-radius: 12px;\n}\n\n.ncd-search-input {\n  border: none;\n  outline: none;\n  background: transparent;\n  font-size: 0.85rem;\n  color: #334155;\n  width: 100%;\n}\n\n.ncd-search-input::placeholder {\n  color: #94a3b8;\n}\n\n/* ── Tabs row ─────────────────────────────────────────────── */\n.ncd-tabs-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 12px 24px;\n  flex-wrap: wrap;\n}\n\n.ncd-seg {\n  display: inline-flex;\n  background: #e9eef5;\n  border-radius: 12px;\n  padding: 4px;\n  gap: 2px;\n}\n\n.ncd-seg-btn {\n  border: none;\n  background: transparent;\n  padding: 7px 16px;\n  border-radius: 9px;\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: #64748b;\n  cursor: pointer;\n  transition: all 0.15s;\n  white-space: nowrap;\n}\n\n.ncd-seg-btn.active {\n  background: linear-gradient(180deg, #3b82f6, #2563eb);\n  color: #fff;\n  box-shadow: 0 2px 8px rgba(37, 99, 235, 0.3);\n}\n\n.ncd-pills {\n  display: inline-flex;\n  gap: 8px;\n}\n\n.ncd-pill {\n  border: 1px solid #e2e8f0;\n  background: #fff;\n  padding: 7px 16px;\n  border-radius: 999px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: #64748b;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.ncd-pill:hover:not(.active) {\n  border-color: #cbd5e1;\n}\n\n.ncd-pill.active {\n  background: #2563eb;\n  border-color: #2563eb;\n  color: #fff;\n}\n\n/* ── List ─────────────────────────────────────────────────── */\n.ncd-list {\n  flex: 1;\n  overflow-y: auto;\n  padding: 4px 24px 28px;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n/* ── Card ─────────────────────────────────────────────────── */\n.ncd-card {\n  position: relative;\n  display: flex;\n  gap: 14px;\n  background: #fff;\n  border: 1px solid #eef2f7;\n  border-radius: 16px;\n  padding: 18px 20px;\n  cursor: pointer;\n  transition:\n    box-shadow 0.15s,\n    border-color 0.15s,\n    opacity 0.15s;\n}\n\n.ncd-card:hover {\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);\n  border-color: #e2e8f0;\n}\n\n.ncd-card.read {\n  opacity: 0.62;\n}\n\n.ncd-card-unread {\n  position: absolute;\n  top: 18px;\n  left: 8px;\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: #2563eb;\n}\n\n.ncd-card-avatar {\n  width: 46px;\n  height: 46px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  font-weight: 700;\n}\n\n.ncd-emoji {\n  font-size: 1.35rem;\n  line-height: 1;\n}\n\n.ncd-card-main {\n  flex: 1;\n  min-width: 0;\n}\n\n.ncd-card-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 7px;\n  margin-bottom: 7px;\n}\n\n.ncd-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 3px 10px;\n  border-radius: 999px;\n  font-size: 0.72rem;\n  font-weight: 600;\n  background: #f1f5f9;\n  color: #475569;\n  text-transform: capitalize;\n}\n\n.ncd-prio-high {\n  background: #fee2e2;\n  color: #dc2626;\n}\n\n.ncd-prio-medium {\n  background: #fef3c7;\n  color: #d97706;\n}\n\n.ncd-prio-low {\n  background: #ecfdf5;\n  color: #059669;\n}\n\n.ncd-chip-new {\n  background: #dbeafe;\n  color: #2563eb;\n}\n\n.ncd-card-title {\n  margin: 0 0 4px;\n  font-size: 0.98rem;\n  font-weight: 700;\n  color: #0f172a;\n  letter-spacing: -0.01em;\n}\n\n.ncd-card-desc {\n  margin: 0 0 12px;\n  font-size: 0.85rem;\n  color: #64748b;\n  line-height: 1.5;\n}\n\n.ncd-card-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.ncd-card-meta {\n  font-size: 0.8rem;\n  color: #475569;\n  font-weight: 500;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.ncd-card-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 2px;\n  border: none;\n  background: transparent;\n  color: #2563eb;\n  font-size: 0.82rem;\n  font-weight: 600;\n  cursor: pointer;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.ncd-card-link:hover {\n  text-decoration: underline;\n}\n\n.ncd-card-time {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 0.72rem;\n  color: #94a3b8;\n  white-space: nowrap;\n  flex-shrink: 0;\n  align-self: flex-start;\n}\n\n/* ── Empty ────────────────────────────────────────────────── */\n.ncd-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  padding: 70px 20px;\n  color: #94a3b8;\n  font-size: 0.9rem;\n}\n\n@media (max-width: 640px) {\n  .ncd-header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  .ncd-card-time {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
